import { makeObservable, observable } from 'mobx'
import type { FirebaseRepository } from '../models/FirebaseRepository'
import { BackendConfigModel } from './BackendConfigModel'
import { Cubit } from './core'
import { getSettingsLti, updateSettingsLti } from '../firestore/SettingsLti'
import { SettingsLti } from '../models/SettingsLti'

export class ProfileCubit extends Cubit {
  repository: FirebaseRepository

  moderationConfig: BackendConfigModel
  gradingConfig: BackendConfigModel
  transcriptionConfig: BackendConfigModel
  ltiSettings: SettingsLti

  @observable
  slideDecksInitialized = false

  constructor(repository: FirebaseRepository) {
    super()
    this.repository = repository

    this.moderationConfig = new BackendConfigModel(
      this.repository,
      'moderation_config'
    )
    this.gradingConfig = new BackendConfigModel(
      this.repository,
      'grading_config'
    )
    this.transcriptionConfig = new BackendConfigModel(
      this.repository,
      'transcription_config'
    )
    this.ltiSettings = SettingsLti.empty(this.repository)

    makeObservable(this)
  }

  startLtiSettingsStream() {
    if (this.repository.inProductionOrBeta) return
    if (this.hasStream('settings-lti')) return

    this.addStream(
      getSettingsLti(this.repository),
      (settings) => {
        this.ltiSettings.replaceModel(settings)
      },
      { name: 'settings-lti' }
    )
  }

  updateBreakoutAppUrl(breakoutAppUrl: string) {
    if (this.repository.inProductionOrBeta) {
      throw new Error(
        'LTI settings updates are disabled in production and beta.'
      )
    }
    return updateSettingsLti(this.repository, { breakoutAppUrl })
  }
}
